import { AlertEntity, HistoricalAlert } from '@src/types/Alerts';

const ALERT_ID_SEPARATOR = '||';

export const getAlertId = (alert: AlertEntity | HistoricalAlert) =>
  `${alert.topic}${ALERT_ID_SEPARATOR}${alert.ts}`;

export const getAlertTopicFromId = (alertId: string) =>
  alertId.split(ALERT_ID_SEPARATOR)[0];
